import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const CN_TZ = 'Asia/Shanghai';

// 后端统一存 UTC 时间；显示时一律换算为北京时间
export const cnDay = (t) => (t ? dayjs.utc(t).tz(CN_TZ) : null);

export const fmtCN = (t, fmt = 'YYYY-MM-DD HH:mm') => (t ? dayjs.utc(t).tz(CN_TZ).format(fmt) : '');

// 当前北京时间（用于本地生成的时间戳文案）
export const nowCN = (fmt = 'YYYY-MM-DD HH:mm') => dayjs().tz(CN_TZ).format(fmt);

export default dayjs;
